// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Entity Kind
 * @export
 * @enum {string}
 */
export var EntityKind;
(function (EntityKind) {
    EntityKind["Portfolio"] = "Portfolio";
    EntityKind["InvestorAccounts"] = "InvestorAccounts";
    EntityKind["Funds"] = "Funds";
    EntityKind["Managers"] = "Managers";
    EntityKind["Assets"] = "Assets";
    EntityKind["FundSeries"] = "FundSeries";
})(EntityKind || (EntityKind = {}));
export function EntityKindFromJSON(json) {
    return json;
}
export function EntityKindToJSON(value) {
    return value;
}
